import { useTranslation } from 'react-i18next';
import { ControlledMultiPickerWithCategory } from 'src/shared/components/form/controlledMultiPickerWithCategory';
import { Grid } from '@mui/material';
import { ControlledCheckboxNew } from 'src/shared/components/form/controlledCheckboxNew';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { TitlePickerItem } from '../models/titlePickerItem';

type MemberAdvancedSearchTitleProps = {
  titles: TitlePickerItem[];
};

// Returnerar grid-items direkt in i sektionens Grid container så uppdrags-pickern får samma bredd
// som övriga fält (~1/3), istället för att spänna över hela raden.
export const MemberAdvancedSearchTitle = ({ titles }: MemberAdvancedSearchTitleProps) => {
  const { t } = useTranslation(['common', 'member']);

  return (
    <>
      <Grid item xs={12} md={6} lg={4}>
        <ControlledMultiPickerWithCategory<TitlePickerItem>
          name='titleIds'
          limitTags={2}
          componentWidth='100%'
          callback={(x) => {
            ConsoleHelper.log(x);
          }}
          showCategory
          fetchMethod={async () => titles}
          label={t('member:memberAdvancedSearch.titleIds')}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={4} sx={{ display: 'flex', alignItems: 'center' }}>
        <ControlledCheckboxNew name='includeResignedTitles' label={t('member:memberAdvancedSearch.includeResignedTitles')} />
      </Grid>
    </>
  );
};
